module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "0px",
      "font-size": "20px",
      "letter-spacing": "0px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Den Dover never knew his father until the end of the wars in Europe and Burma. He lived halfway between Liverpool and Manchester under the bombers’ airpaths. American soldiers and airmen were the heroes of his childhood years. Churchill was his hero and the saviour of Britain. Den resolved that he would follow Churchill by dedicating his life to caring and providing for the people by becoming a Member of Parliament.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0